module.exports = __webpack_public_path__ + "teacherALQ-44f8b59a9308d7994666406870c8c0c9.png";